import { render, staticRenderFns } from "./mediationDetail.vue?vue&type=template&id=32711fa8"
import script from "./mediationDetail.vue?vue&type=script&lang=js"
export * from "./mediationDetail.vue?vue&type=script&lang=js"
import style0 from "./mediationDetail.vue?vue&type=style&index=0&id=32711fa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports